import { Flex } from 'antd';
import { useTheme } from 'styled-components';

import { Button, Icon, Text } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

import { Theme } from '../../../store/viewer/viewer.types';
import { useThemeModeHandler } from '../../hooks/useThemeModeHandler';

export type ThemeModeSwitchProps = {
  type: 'button' | 'icon';
};

export const ThemeModeSwitch = ({ type }: ThemeModeSwitchProps) => {
  const { toggleThemeMode, themeMode } = useThemeModeHandler();
  const theme = useTheme();
  const { t } = useTranslation();
  const isThemeLight = themeMode === Theme.Light;

  if (type === 'icon') {
    return (
      <Button
        variant="ghost"
        size="Small"
        action={'switch-theme'}
        dataset={{
          theme: theme.Version,
        }}
        icon={{
          name: isThemeLight ? 'moon' : 'sun',
        }}
        onClick={toggleThemeMode}
      />
    );
  }

  return (
    <Flex data-testid="theme-switch" data-action={'switch-theme'} role="button" onClick={toggleThemeMode}>
      <Flex gap={theme.Sizes.Small} flex={1}>
        <Icon name="light-bulb" color={theme.Color.Neutrals.Text} />
        <Text size="Body">{t('tool.theme.theme_mode_title')}</Text>
      </Flex>
      <Flex gap={theme.Sizes.Small}>
        {themeMode === 'dark' ? (
          <Text size="Body">{t('tool.theme.dark')}</Text>
        ) : (
          <Text size="Body">{t('tool.theme.light')}</Text>
        )}
        <Icon name="chevron---right" color={theme.Color.Neutrals.Text} />
      </Flex>
    </Flex>
  );
};
